import React, { useState } from 'react';
import { ClientTags } from '../../molecules/ClientTags';
import { ClientGrid } from '../ClientGrid';
import { useLanguage } from '@/contexts/LanguageContext';
import styles from './ClientsSection.module.css';
import { GradientText, ServicesTitle } from '@/components/atoms';

interface ClientsSectionProps {
  className?: string;
}

// Gradient markers for different languages
const GRADIENT_MARKERS = {
  en: 'their stories',
  fr: 'leurs histoires',
} as const;

type SupportedLanguage = keyof typeof GRADIENT_MARKERS;

export const ClientsSection: React.FC<ClientsSectionProps> = ({
  className,
}) => {
  const { t, language } = useLanguage();
  const [selectedTag, setSelectedTag] = useState('All');

  const handleTagSelect = (tag: string) => {
    setSelectedTag(tag);
  };

  const fullTitle = t('home.clients.title');
  const lang = language as SupportedLanguage;
  const gradientPart = GRADIENT_MARKERS[lang] ?? GRADIENT_MARKERS.en;
  const titleWithoutGradient = fullTitle.replace(gradientPart, '').trim();

  return (
    <section
      className={`${styles.clientsSection} ${className || ''}`}
      aria-label="Clients"
    >
      <div className={styles.contentWrapper}>
        <ServicesTitle>{t('home.clients.label')}</ServicesTitle>
        <div className={styles.heroContainer}>
          <h2 className={styles.heroTitle}>
            {titleWithoutGradient} <GradientText>{gradientPart}</GradientText>
          </h2>
        </div>
        <ClientTags onTagSelect={handleTagSelect} selectedTag={selectedTag} />
        <ClientGrid tagFilter={selectedTag} />
      </div>
    </section>
  );
};
